import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { CreateNewLiteral, EditLiteral } from '../actions/search-literals.actions';
import { CloseLiteralsSidenav, OpenLiteralsSidenav } from '../actions/sidenav.actions';

export interface SidenavState {
  sidenavStatus: boolean;
  showLocaleLiteral: boolean;
}

const initialState: SidenavState = {
  sidenavStatus: false,
  showLocaleLiteral: false,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenLiteralsSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(EditLiteral, (state) => ({
    ...state,
    sidenavStatus: true,
    showLocaleLiteral: true,
  })),
  on(CreateNewLiteral, (state) => ({
    ...state,
    sidenavStatus: true,
    showLocaleLiteral: true,
  })),
  on(CloseLiteralsSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
    showLocaleLiteral: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
    showLocaleLiteral: false,
  })),
);
